export default __webpack_public_path__ + "static/media/personaje--Banner2-Inscripción.bd29b005.png";